// Generic Carousel functionality - supports multiple carousels
function initCarousel(carouselElement: HTMLElement) {
  const track = carouselElement.querySelector('.carousel-track') as HTMLElement | null;
  const prevButton = carouselElement.querySelector('.carousel-prev') as HTMLButtonElement | null;
  const nextButton = carouselElement.querySelector('.carousel-next') as HTMLButtonElement | null;

  if (!track || !prevButton || !nextButton) return;

  let currentIndex = 0;
  const totalImages = track.children.length;

  const updateCarousel = () => {
    const translateX = -currentIndex * 100;
    track.style.transform = `translateX(${translateX}%)`;
  };

  prevButton.addEventListener('click', (e) => {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + totalImages) % totalImages;
    updateCarousel();
  });

  nextButton.addEventListener('click', (e) => {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % totalImages;
    updateCarousel();
  });

  // Open current image in new tab when clicking on carousel (not on buttons)
  carouselElement.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'BUTTON' || target.closest('button')) return;
    
    const currentImage = track.children[currentIndex] as HTMLImageElement;
    if (currentImage && currentImage.src) {
      window.open(currentImage.src, '_blank');
    }
  });
}

// Initialize all carousels on the page
document.querySelectorAll('.carousel').forEach((carousel) => {
  initCarousel(carousel as HTMLElement);
});

function initRenameToast() {
  const toast = document.createElement('a');
  toast.href = 'https://www.intercompany.nl/';
  toast.className =
    'fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-[60] mx-auto sm:mx-0 max-w-md ' +
    'rounded-xl bg-[#003DA5] px-4 py-3.5 text-sm sm:text-base text-white font-habibi ' +
    'shadow-lg shadow-black/20 ring-1 ring-white/10 ' +
    'transition-all hover:bg-[#002d7a] hover:scale-[1.02] active:scale-[0.98] ' +
    'flex items-center justify-between gap-3';
  toast.setAttribute('role', 'status');
  toast.setAttribute(
    'aria-label',
    'Stichting Sibi wordt Intercompany Nederland. Ga naar de nieuwe website.',
  );

  const label = document.createElement('span');
  label.textContent = 'Stichting Sibi wordt Intercompany Nederland.';

  const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  arrow.setAttribute('class', 'h-5 w-5 shrink-0 opacity-90');
  arrow.setAttribute('viewBox', '0 0 20 20');
  arrow.setAttribute('fill', 'currentColor');
  arrow.setAttribute('aria-hidden', 'true');
  const arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  arrowPath.setAttribute('fill-rule', 'evenodd');
  arrowPath.setAttribute(
    'd',
    'M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z',
  );
  arrowPath.setAttribute('clip-rule', 'evenodd');
  arrow.appendChild(arrowPath);

  toast.append(label, arrow);
  document.body.appendChild(toast);
}

initRenameToast();